module.exports = __webpack_public_path__ + "img/142.2.bd53015a.png";